// frontend/src/components/ChatView.js
import React from 'react';
import {
    Flex,
    Spinner,
    Center,
    Text,
} from '@chakra-ui/react';
import ConversationList from './ConversationList';
import MessageDisplay from './MessageDisplay';
import MessageInput from './MessageInput';
import ErrorDisplay from './ErrorDisplay';

const ChatView = ({
    // Conversation list
    conversations,
    currentConversationId,
    onSelectConversation,
    onNewConversation,
    onDeleteConversation,
    onRenameConversation,
    onMoveConversation,
    workspaces,
    currentWorkspaceId,
    onBulkDeleteConversations,
    // Message display
    messageDisplayRef,
    messages,
    error,
    isLoading,
    isLoadingConversation,
    currentModelDisplayName,
    onDuplicateConversation,
    // Retry
    retryState,
    onRetry,
    onRetryCancel,
    // Message input
    onSubmit,
    model,
    setModel,
    systemPrompt,
    setSystemPrompt,
}) => {
    return (
        <>
            <ConversationList
                conversations={conversations}
                onSelect={onSelectConversation}
                onNewConversation={onNewConversation}
                onDelete={onDeleteConversation}
                onRename={onRenameConversation}
                onMove={onMoveConversation}
                workspaces={workspaces}
                currentWorkspaceId={currentWorkspaceId}
                onBulkDelete={onBulkDeleteConversations}
                currentConversationId={currentConversationId}
            />
            <Flex flex="1" direction="column" minW="0" overflow="hidden">
                {isLoadingConversation ? (
                    <Center flex="1">
                        <Spinner size="xl" color="brand.500" />
                        <Text ml={4}>Loading conversation...</Text>
                    </Center>
                ) : (
                    <>
                        <MessageDisplay
                            ref={messageDisplayRef}
                            messages={messages}
                            error={error}
                            isLoading={isLoading}
                            onDuplicateConversation={onDuplicateConversation}
                            currentConversationId={currentConversationId}
                            currentModel={currentModelDisplayName}
                        />

                        {retryState.errorInfo && retryState.errorInfo.showRetry && (
                            <ErrorDisplay
                                errorInfo={retryState.errorInfo}
                                onRetry={onRetry}
                                onCancel={onRetryCancel}
                                isRetrying={retryState.isRetrying}
                            />
                        )}
                    </>
                )}
                <MessageInput
                    handleSubmit={onSubmit}
                    model={model}
                    setModel={setModel}
                    isLoading={isLoading}
                    systemPrompt={systemPrompt}
                    setSystemPrompt={setSystemPrompt}
                />
            </Flex>
        </>
    );
};

export default ChatView;